export default "__VITE_ASSET__be5fb38c__"